import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'ecareltc-vitals-facility-filter'

interface FacilityFilterState {
  facilityId: string | null  // null = All Facilities
}

type Listener = () => void

class FacilityFilterStore {
  private state: FacilityFilterState
  private listeners = new Set<Listener>()

  constructor() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY)
      const saved = raw ? (JSON.parse(raw) as { facilityId: string | null }) : null
      this.state = { facilityId: saved?.facilityId ?? null }
    } catch {
      this.state = { facilityId: null }
    }
  }

  subscribe = (listener: Listener) => {
    this.listeners.add(listener)
    return () => { this.listeners.delete(listener) }
  }

  getSnapshot = () => this.state

  private notify() {
    this.listeners.forEach((l) => l())
  }

  setFacility(facilityId: string | null) {
    this.state = { facilityId }
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ facilityId }))
    } catch { /* ignore */ }
    this.notify()
  }

  clear() {
    this.setFacility(null)
  }
}

export const facilityFilterStore = new FacilityFilterStore()

export function useFacilityFilter() {
  const state = useSyncExternalStore(
    facilityFilterStore.subscribe,
    facilityFilterStore.getSnapshot,
    facilityFilterStore.getSnapshot,
  )
  return {
    facilityId: state.facilityId,
    setFacility: (id: string | null) => facilityFilterStore.setFacility(id),
    clear: () => facilityFilterStore.clear(),
  }
}
